import { render, staticRenderFns } from "./iTextField.vue?vue&type=template&id=351670ed&"
import script from "./iTextField.vue?vue&type=script&lang=js&"
export * from "./iTextField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports